export default __webpack_public_path__ + "static/meshfair2024-7b92a455f82b179752b1de2a0b4e2240.jpg";